import React, { useEffect, useState, useRef } from 'react';
import { motion } from 'framer-motion';
interface BlurTextProps {
  text: string;
  delay?: number;
  className?: string;
  animateOnView?: boolean;
  splitBy?: 'word' | 'char';
}
export function BlurText({
  text,
  delay = 0,
  className = '',
  animateOnView = true,
  splitBy = 'word'
}: BlurTextProps) {
  const ref = useRef<HTMLSpanElement>(null);
  const [inView, setInView] = useState(!animateOnView);
  useEffect(() => {
    if (!animateOnView) return;
    const observer = new IntersectionObserver(([entry]) => {
      if (entry.isIntersecting) {
        setInView(true);
        observer.disconnect();
      }
    }, {
      threshold: 0.1,
      rootMargin: '-50px'
    });
    if (ref.current) observer.observe(ref.current);
    return () => observer.disconnect();
  }, [animateOnView]);
  const parts = splitBy === 'char' ? text.split('') : text.split(/(\s+)/);
  return <span ref={ref} className={`inline-block ${className}`} data-id="element-208">
      {parts.map((part, i) => {
      if (part.match(/^\s+$/)) {
        return <span key={i} data-id="element-209">{part}</span>;
      }
      return <motion.span key={i} initial={{
        opacity: 0,
        filter: 'blur(12px)',
        y: 8
      }} animate={inView ? {
        opacity: 1,
        filter: 'blur(0px)',
        y: 0
      } : {
        opacity: 0,
        filter: 'blur(12px)',
        y: 8
      }} transition={{
        duration: 0.6,
        delay: delay + i * (splitBy === 'char' ? 0.015 : 0.05),
        ease: [0.25, 0.4, 0.25, 1]
      }} className="inline-block" style={{
        willChange: 'filter, opacity, transform'
      }} data-id="element-210">
            {part}
          </motion.span>;
    })}
    </span>;
}